import React from 'react';
import { COLORS } from '../../config/designSystem/Colors';
import { DropShadowLightCloseStyle } from '../../config/designSystem/Shadow';
import { H4, ParagraphMRegular, ParagraphSBold } from '../../config/designSystem/typography';
import { Modal, Pressable, StyleSheet, View } from 'react-native';
import { SPACING } from '../../config/designSystem/Spacing';

// In-house replacement for react-native-awesome-alerts (unmaintained; its
// BackHandler.removeEventListener call needed patching on RN 0.86). Covers the one
// shape the app ever used: title + message + cancel/confirm.

interface ConfirmDialogProps {
  visible: boolean;
  title?: string;
  message?: string;
  cancelText?: string;
  confirmText?: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ConfirmDialog = ({ visible, title, message, cancelText, confirmText, onCancel, onConfirm }: ConfirmDialogProps) => {
  return (
    <Modal visible={visible} transparent animationType="fade" statusBarTranslucent onRequestClose={onCancel}>
      <Pressable style={styles.backdrop} onPress={onCancel}>
        {/* stopPropagation so taps inside the card do not dismiss */}
        <Pressable style={styles.card} onPress={() => {}}>
          {!!title && <H4 align={true}>{title}</H4>}
          {!!message && <ParagraphMRegular align={true} style={styles.message}>{message}</ParagraphMRegular>}
          <View style={styles.buttons}>
            <Pressable accessibilityRole="button" style={[styles.button, styles.cancel]} onPress={onCancel}>
              <ParagraphSBold color={COLORS.content.primary}>{cancelText}</ParagraphSBold>
            </Pressable>
            <Pressable accessibilityRole="button" style={[styles.button, styles.confirm]} onPress={onConfirm}>
              <ParagraphSBold color="#fff">{confirmText}</ParagraphSBold>
            </Pressable>
          </View>
        </Pressable>
      </Pressable>
    </Modal>
  );
};

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: 'rgba(20, 22, 43, 0.55)',
    alignItems: 'center',
    justifyContent: 'center',
    padding: SPACING['sp-24'],
  },
  card: {
    width: '100%',
    maxWidth: 400,
    borderRadius: SPACING['sp-12'],
    backgroundColor: COLORS.surface.contrast,
    padding: SPACING['sp-24'],
    rowGap: SPACING['sp-12'],
    ...DropShadowLightCloseStyle,
  },
  message: {
    marginTop: SPACING['sp-4'],
  },
  buttons: {
    flexDirection: 'row',
    justifyContent: 'center',
    columnGap: SPACING['sp-12'],
    marginTop: SPACING['sp-16'],
  },
  button: {
    borderRadius: SPACING['sp-8'],
    paddingVertical: SPACING['sp-8'],
    paddingHorizontal: SPACING['sp-16'],
    alignItems: 'center',
    justifyContent: 'center',
  },
  cancel: {
    backgroundColor: COLORS.surface.primary,
  },
  confirm: {
    backgroundColor: COLORS.brand[500],
  },
});
